module.exports = __webpack_public_path__ + "img/My_Feedback.7144263d.svg";